import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CmsConfig, provideDefaultConfig} from '@spartacus/core';
import {CustomDcpConfiguratorSinglePageFormComponent} from './custom-dcp-configurator-single-page-form.component';

import {DcpConfiguratorSinglePageFormComponent} from '@dcp/configurator';

@NgModule({
  imports: [DcpConfiguratorSinglePageFormComponent, CustomDcpConfiguratorSinglePageFormComponent],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ConfiguratorForm: {
          component: CustomDcpConfiguratorSinglePageFormComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [CustomDcpConfiguratorSinglePageFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomDcpConfiguratorSinglePageFormModule {}
